export default __webpack_public_path__ + "static/media/florenceAndTheMachine.ae1eec22.jpeg";